var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePaymentRadioInput',{attrs:{"selected-payment-method":_vm.selectedPaymentMethod,"numeric-value":3,"name":"simplepay","title-text":_vm.$t('form.online-payment-method.title'),"subtitle-text":_vm.$t('form.online-payment-method.subtitle'),"update-value":(value) => _vm.$emit('update-payment-method', value),"logo":{
        url: 'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf',
        img: require('~/assets/images/logos/simplepay.png'),
        alt: 'SimplePay',
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }